import { render, staticRenderFns } from "./StructurerDetail.vue?vue&type=template&id=70d41e7e&scoped=true"
import script from "./StructurerDetail.vue?vue&type=script&lang=js"
export * from "./StructurerDetail.vue?vue&type=script&lang=js"
import style0 from "./StructurerDetail.vue?vue&type=style&index=0&id=70d41e7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d41e7e",
  null
  
)

export default component.exports